<ul [class.no-menu]="!isMenu">
  <li *ngFor="let item of links; let i = index">
    <a class="cursor-pointer" [style.color]="i > 0 ? (registerButtonColor$ | async)?.toString() : null"
      (click)="item.url === '#logout' ? logout($event) : handleClick($event, item.url)">
      {{ item.title }}
    </a>
  </li>
</ul>
